import CookieConsent from './gdpr-cookie-consent-banner/lib/index';
import { GtmUtils } from './gtm-utils';

const consentmanager = (() => {
  const _COOKIENAME_ = 'ob_consent';
  const cookieModal = document.getElementById('modal');

  /** if there is no modal, do nothing  */
  if (cookieModal == null) {
    console.error('Cannot find modal element');
    return;
  }

  // static Cookie Object to read, modify or delete cookies
  const Cookie = CookieConsent.cookie;

  // These are the current editable Categories we use at Orderbird
  // we make an array of objects and use cookie names in this
  const editableCatObj = {
    necessary: [
      '__cfduid',
      '__cf_bm',
      'CRAFT_CSRF_TOKEN',
      'csrftoken',
      'CraftSessionId',
      'sessionid',
      'form_posted_X',
      'language',
      'obClosedElements',
      'ob_consent',
      '_secure_session_id',
      'Cart',
      'cart_sig',
      'cart_ts',
      'checkout_token',
      'Secret',
      'taboola_session_id',
      't_gid',
      'DNT',
      'chat-jwt',
      'convId_',
      'AWSALBCORS',
      'AWSALB',
    ],
    statistics: [
      '_ga',
      '/^_ga.*/',
      '_ga_\\d+',
      '_gid',
      '_gat',
      'SAPISID',
      'SID',
      'SSID',
      'SIDCC',
    ],
    performance: [
      '_vis_opt_s',
      '_vwo_uuid',
      '_vis_opt_test_cookie',
      '_vwo_sn',
      '_vwo_ds',
      '_vwo_uuid_v2',
    ],
    marketing: [
      '_biz_flagsA',
      '_biz_nA',
      '_biz_pendingA',
      '_biz_sid',
      '_biz_uid',
      'NID',
      'IDE',
      'CONSENT',
      'ANID',
      '1P_JAR',
      'MUID',
      'MUIDB',
      'personalization_id',
      'fr',
      '_fbp',
      '_gcl_au',
      'test_cookie',
      'eu_cn',
      'guest_id',
      'ct0',
      'tfw_exp',
      '_tt_enable_cookie',
      '_ttp',
      '_tt_sessionId',
      '_pin_unauth',
      '_uetvid',
      '_uetsid',
    ],
    others: [],
  };

  /** expand collapse individual settings block  */
  const acceptAllBtn = cookieModal.querySelector('.accept_all');
  const declineAllBtn = cookieModal.querySelector('.decline_all');
  const expandBtn = cookieModal.querySelector('.toggle-settings');
  const backBtn = cookieModal.querySelector('.back');
  const expandBlock = cookieModal.querySelector('.individual-settings');

  if (expandBtn && expandBlock && acceptAllBtn && declineAllBtn && backBtn) {
    expandBtn.addEventListener('click', (e) => {
      if (expandBlock.classList.contains('hidden')) {
        _showElement(expandBlock);
        _hideElement(acceptAllBtn);
        _hideElement(declineAllBtn);
        _hideElement(expandBtn);
      }
    });

    backBtn.addEventListener('click', (e) => {
      _hideElement(expandBlock);
      _showElement(acceptAllBtn);
      _showElement(declineAllBtn);
      _showElement(expandBtn);
    });
  }

  /** cookieObj */
  let choicesObj = {};

  /** try to read if cookie exists  */
  const readCookie = Cookie.get(_COOKIENAME_);
  if (readCookie != null && typeof readCookie === 'object') {
    if (readCookie.choices != undefined && Array.isArray(readCookie.choices)) {
      readCookie.choices.forEach((el) => {
        choicesObj[el.name] = el.value;
      });
    }
  }

  const editableCapabilities = [];

  const editableCats = Object.keys(editableCatObj);

  editableCats.forEach((el, i) => {
    /** set checkbox if possible */
    if (
      choicesObj &&
      choicesObj[el] !== undefined &&
      cookieModal.querySelector('#choice-' + el) != null &&
      cookieModal.querySelector('#choice-' + el).getAttribute('type') ==
        'checkbox'
    ) {
      cookieModal.querySelector('#choice-' + el).checked = choicesObj[el];
    }

    editableCapabilities.push({
      name: el,
      checked:
        choicesObj && choicesObj[el] !== undefined ? choicesObj[el] : false, // for now just set to true, we will read the cookie and update it in a while
      onAccept: (consent) => {},
      onReject: (consent) => {},
      onValueChange: (consent, { choice }) => {},
    });
  });

  // Define one functional capability and get the rest from above
  const obCapabilities = [
    {
      name: 'necessary',
      checked: true,
    },
    ...editableCapabilities,
  ];

  // push choices to dataLayer
  obCapabilities.forEach((choice) => _pushDLayer(choice.name, choice.checked));

  //at every page load we need to provide default consent
  GtmUtils.pushDefaultConsent(
    obCapabilities.map((entry) => ({
      name: entry.name,
      value: entry.checked,
    })),
  );

  window.consent = new CookieConsent({
    name: _COOKIENAME_,
    onAcceptEnd: (consent) => {
      deleteNonNecessaryCookies();
      setConsentChoices([{ name: 'necessary', value: true }]);
      loadTrackingScripts();
    },
    onRejectEnd: (consent) => {},
    onConsent: (consent) => {},
    // the capabilities array needs to be defined for each added category
    capabilities: obCapabilities,
  });

  /** accept all button handle  */
  if (acceptAllBtn != null) {
    acceptAllBtn.addEventListener('click', (e) => {
      cookieModal.querySelectorAll('.choice input').forEach((node) => {
        if (!node.disabled) {
          node.checked = true;
        }
      });
      loadTrackingScripts();
      setConsentChoices();
    });
  }

  /** decline all button handle  */
  if (declineAllBtn != null) {
    declineAllBtn.addEventListener('click', (e) => {
      cookieModal.querySelectorAll('.choice input').forEach((node) => {
        if (!node.disabled) {
          node.checked = false;
        }
      });
      loadTrackingScripts();
      setConsentChoices();
    });
  }

  /** check for change-cookie-preferences anchor element to trigger banner display */
  const triggerButton = document.querySelector('a.change-cookie-preferences');
  if (triggerButton) {
    triggerButton.addEventListener('click', (e) => {
      e.preventDefault();
      _triggerBanner();
    });
  }

  /** function to push events into data layer in window */
  function _pushDLayer(cookieName, consentVal = false) {
    if (cookieName) {
      let adaptedCookieName = cookieName.toLowerCase();
      window.dataLayer = GtmUtils.getDataLayer();
      GtmUtils.getDataLayer().push({
        ['consent_' + adaptedCookieName]: consentVal,
      });
    }
  }

  const setConsentChoices = (choices = []) => {
    cookieModal.querySelectorAll('.choice input').forEach((node) => {
      const name = node.getAttribute('name').replace('choice:', '');
      const value = node.checked;
      pushUniqueChoices(choices, { name, value });
      _pushDLayer(name, value);
    });

    consent.saveUserOptions({ choices, consented: true });
    _hideElement(cookieModal);

    GtmUtils.pushEventToDataLayer('consent_saved');
    GtmUtils.pushUpdatedConsent(choices);
  };

  /**
   * Remove old object from the array of choices and add new choice to array
   * @param {array} choices
   * @param {object} choice
   */
  function pushUniqueChoices(choices, choice) {
    let index = choices.findIndex((obj) => obj['name'] === choice['name']);
    if (index !== -1) {
      choices.splice(index, 1);
    }
    choices.push(choice);
  }

  function deleteNonNecessaryCookies() {
    const cookieDomain = location.hostname
      .split('.')
      .reverse()
      .splice(0, 2)
      .reverse()
      .join('.');
    const cookies = Cookie.getAll();
    const necessaryCookies = editableCatObj['necessary'];
    for (const name in cookies) {
      if (!necessaryCookies.includes(name)) {
        Cookie.delete(name, cookieDomain, '/');
      }
    }
  }

  /**
   * Load tracking scripts set from craftAdmin
   */
  function loadTrackingScripts() {
    loadGoogleTagManager();
    loadVWOScript();
  }

  /**
   * Trigger Google Tag Manager Script
   */
  function loadGoogleTagManager() {
    if (window.triggerGoogleTagManagerScript) {
      window.triggerGoogleTagManagerScript();
    }
  }

  /**
   * Trigger VWOScript if consented
   */
  function loadVWOScript() {
    if (consent.getChoice('performance') && window.triggerVWOScript) {
      window.triggerVWOScript();
    }
  }

  function _hideElement(element) {
    if ('animate' in element) {
      element
        .animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 160,
          iterations: 1,
        })
        .addEventListener('finish', function onFinish() {
          element.classList.add('hidden');
        });
    } else {
      element.classList.add('hidden');
    }
  }

  function _showElement(element) {
    if ('animate' in element) {
      element
        .animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 320,
          iterations: 1,
        })
        .addEventListener('finish', function onFinish() {
          element.classList.remove('hidden');
        });
    } else {
      element.classList.remove('hidden');
    }
  }

  /** triggerBanner - this will be used in the external link in the cookie policy page */
  function _triggerBanner() {
    _showElement(cookieModal);
  }

  /** section where the cookie will be checked for and the banner will be displayed */
  if (
    (readCookie == null ||
      (readCookie.consented && readCookie.consented == false)) &&
    !cookieModal.classList.contains('obconsent-modal')
  ) {
    window.addEventListener(
      'load',
      () => setTimeout(_showElement, 1000, cookieModal),
      true,
    );
  } else {
    loadTrackingScripts();
  }

  /** handle showcookiebanner click to display banner again
   * TBD - do we select by css class or some data-attribute?
   */

  const showBannerElem = document.querySelector(
    'a[data-popup="showcookiebanner"]',
  );
  if (showBannerElem != undefined) {
    showBannerElem.addEventListener('click', function () {
      _showElement(cookieModal);
    });
  }
})();

export default consentmanager;
